module.exports = __webpack_public_path__ + "media/images/admin/icons/unlock-48d2d175e232a9c4585ffed18a8ad9df.svg";